/**
 * Abre o painel de conversa da Beaa (componente próprio do site).
 * Dispara um evento global que o lançador da Beaa escuta para abrir o chat.
 */
export const BEAA_OPEN_CHAT_EVENT = 'beaa:open-chat';

export function openBeaaChat(mensagemInicial?: string) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(BEAA_OPEN_CHAT_EVENT, { detail: { mensagemInicial } }),
  );
}